import { AutoCompleteProps } from "common/component/Autocomplete/types";
import { TagListProps } from "common/component/TagList/types";
import { fromStyleLocals } from "common/css";
import { State } from "common/picker/reducer/types";
import { ContactDto, SearchCriteria } from "common/types/contact";
import { ContactAutocomplete } from "ic-contact-picker/component/ContactAutocomplete";
import { ContactTagList } from "ic-contact-picker/component/ContactTagList";
import { Component, h } from "preact";
import { onClick } from "common/picker/utils";

import * as stylesheet from "./TagPicker.less";
const css = fromStyleLocals(stylesheet.locals);

export interface TagPickerProp
  extends TagListProps<ContactDto, SearchCriteria>,
    AutoCompleteProps<ContactDto, SearchCriteria> {
  onBlur: () => void;
  onStart: () => void;
  criteria: SearchCriteria;
}

export class TagPicker extends Component<
  TagPickerProp & State<ContactDto, SearchCriteria>,
  {}
> {
  public render() {
    const {
      onFocus,
      onInput,
      onRemove,
      onSelect,
      criteria,
      tagList: {
        disabled,
        hasPortfolio,
        tags,
        placeholder,
        displaySearchBy,
        selectedSearchBy,
        state,
      },
      autocomplete: { exclude, isVisible, items, status, reason },
    } = this.props;

    return (
      <div class={css("ic-tag-picker")}>
        <style>{stylesheet.toString()}</style>

        <ContactTagList
          criteria={criteria}
          disabled={disabled}
          displaySearchBy={displaySearchBy}
          selectedSearchBy={selectedSearchBy}
          hasPortfolio={hasPortfolio}
          onFocus={onFocus}
          onInput={onInput}
          onRemove={onRemove}
          placeholder={placeholder}
          tags={tags}
          state={state}
          status={status}
        />

        <ContactAutocomplete
          criteria={criteria}
          exclude={exclude}
          isVisible={isVisible}
          items={items}
          onSelect={onSelect}
          reason={reason}
          status={status}
        />
      </div>
    );
  }

  public componentDidMount() {
    document.addEventListener("click", this.onClick, false);
    this.props.onStart();
  }

  public componentWillUnmount() {
    document.removeEventListener("click", this.onClick);
  }

  private readonly onClick = (e: any) => {
    const clickOutside = onClick(this.base, "IC-CONTACT-PICKER", e);
    if (clickOutside) {
      this.props.onBlur();
    }
    return clickOutside;
  };
}
